import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Auth0LoginButton, buildAuth0PopupUrl, useAuth } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserRegisterComponent` (audit §3/§6.1). Owner
// decision 2026-09-26 (legacy-migration/RULES.md): signup moved to Auth0's
// Universal Login (`?signup=1` -> `screen_hint=signup` server-side) — this
// page is now just the entry point into that flow, same popup+postMessage
// handoff as LoginPage.
export function RegisterPage() {
  const navigate = useNavigate()
  const { status } = useAuth()

  useEffect(() => {
    if (status === 'authenticated') navigate(POST_LOGIN_PATH, { replace: true })
  }, [status, navigate])

  return (
    <div className="portal-card portal-card--auth">
      <h1>Create account</h1>
      <p>
        <Auth0LoginButton
          popupUrl={buildAuth0PopupUrl(AUTH0_LOGIN_URL, { signup: true })}
          expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
          onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
        >
          Register
        </Auth0LoginButton>
      </p>
      <p>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </div>
  )
}
